const labels = {
  closedEventFlag: 'Closure',
  closeCta: 'Close',
  date: 'Date',
  featuredEventFlag: 'Featured Event',
  filteredEventsUnavailableMessage: 'There are no scheduled events occurring for the date and category selected.',
  findAnEvent: 'Find An Event',
  generalEventsUnavailableMessage: 'There are no scheduled events occurring on the date selected.',
  location: 'Location',
  time: 'Time',
  viewAllEventsCta: 'View All Events',
  view: 'View',
  viewAs: 'View As',
  viewDayCta: 'View Day',
  viewDetailsCta: 'View Details'
}

export default labels
